import React from 'react';
import { Link } from 'react-router-dom';
import { productosDestacados } from '../../data/productos';

const ProductosDestacados = () => {
  return (
    <section className="products-section featured-section" id="destacados">
      <div className="section-container">
        <h2 className="section-title">Productos Destacados</h2>
        <p className="section-subtitle">Descubre nuestros muebles más populares</p>
        <div className="products-grid">
          {Object.entries(productosDestacados).map(([productId, product]) => (
            <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
              <div 
                className="placeholder-image" 
                style={{backgroundImage: `url(${product.images[0]})`}}
              ></div>
              <div className="placeholder-content">
                <div className="product-name-container">
                  <h3 className="product-name">🔥 {product.name.toUpperCase()} ⚡</h3>
                </div>
                <div className="product-price-container">
                  <p className="product-price">💰 {product.price} 💰</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductosDestacados;

